module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "firstInSection"
  }, [_c('em', [_vm._v("‘Cut-throat Defence’")]), _c('br'), _vm._v("\n– A defendant implicates a co-accused in the commission of the offence.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("‘To see what is right, and not to do it, is want of courage.’")]), _c('br'), _vm._v("\nConfucius, 551‒479 BC")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68810d8b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 69
// module chunks = 0